import React, { useContext } from 'react';
import { Button, Card, LocaleContext } from 'shared';

import { ContactInformationProps } from './ContactInformation.types';

export const ContactInformation = ({ onOpenEditModal, account, style }: ContactInformationProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <Card className="contact-information" style={style}>
      <Card.Header className="contact-information__header">
        <Card.Title className="contact-information__title">
          {localeContext.formatMessage({ id: 'ACCOUNT.CONTACT-INFORMATION' })}:
        </Card.Title>
        <Button
          type={'portal-lite'}
          icon={['1.25rem', 'pencilBlueIcon']}
          iconAfterText={true}
          onClick={onOpenEditModal}
          className="button--edit-contact"
        >
          {localeContext.formatMessage({ id: 'ACCOUNT.EDIT-SECTION' })}
        </Button>
      </Card.Header>
      <Card.Body className="contact-information__body">
        <Card.Item className="contact-information__name">
          <Card.ItemKey className="contact-information__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.CONTACT-INFORMATION.CONTACT-PERSON' })}:
          </Card.ItemKey>
          <Card.ItemValue className="contact-information__value">{account.contactPerson.name}</Card.ItemValue>
        </Card.Item>
        <Card.Item className="contact-information__phone">
          <Card.ItemKey className="contact-information__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.CONTACT-INFORMATION.PHONE' })}:
          </Card.ItemKey>
          <Card.ItemValue className="contact-information__value">{account.contactPerson.phoneNumber}</Card.ItemValue>
        </Card.Item>
        <Card.Item className="contact-information__email">
          <Card.ItemKey className="contact-information__key">
            {localeContext.formatMessage({ id: 'ACCOUNT.CONTACT-INFORMATION.E-MAIL' })}:
          </Card.ItemKey>
          <Card.ItemValue className="contact-information__value">{account.contactPerson.email}</Card.ItemValue>
        </Card.Item>
      </Card.Body>
    </Card>
  );
};
